import { v4 as uuidv4 } from "uuid";
import { CUSTOME_ATTR_LIST, CUSTOMER_INDUSTRY_LIST, APP_INDUSTRY_LIST } from "../config/common";
import i18n from "@/i18n";


//start--物产品创建页面--start
export const pageInfo = {
    description:
        i18n.global.t('also.ProductLibraryContainsDefinitions'),
    cardInfo: [
        {
            title: i18n.global.t('also.ParentProduct'),
            description: "",
            componentName: "ParentInfo",
        },
        {
            title: i18n.global.t('page.basic-info'),
            description: "",
            componentName: "BaseInfo",
        },
        {
            title: i18n.global.t('page.AttributeDefinition'),
            description:
                i18n.global.t('also.PropertyDeviceThatNotChangeEasily'),
            componentName: "Attribute",
        },
        {
            title: i18n.global.t('page.MeasurementPoint'),
            description: i18n.global.t('also.FrequentlyChangingPropertiesDevice'),
            componentName: "MeasureValue",
        },
        {
            title: i18n.global.t('page.tending.text'),
            description: i18n.global.t('also.CreateMaintenanceItems'),
            componentName: "Repair",
        },
        {
            title: i18n.global.t('page.fault.fault_knowledge_base'),
            description: '',
            componentName: "FaultknowledgeBase",
        },
        {
            title: i18n.global.t('base.data_bank'),
            description: i18n.global.t('also.ProductRelatedDiagramsVideosDocuments'),
            componentName: "Database",
        },
        {
            title: i18n.global.t('base.tag'),
            description: i18n.global.t('also.UsedToRetrieveProducts'),
            componentName: "Tag",
        },
    ],
}
export const dataTypes = [
    { label: i18n.global.t('also.CharacterString'), value: "string" },
    { label: i18n.global.t('also.integer'), value: "number" },
    { label: i18n.global.t('also.double-precisionNumber'), value: "float" },
    { label: i18n.global.t('also.boolean'), value: "boolean" },
]

export const equipStatus = [
    { label: i18n.global.t('在用'), value: "在用" },
    { label: i18n.global.t('报废'), value: "报废" }
]
export const equipDisciplineClass = [
    { label: "机械设备-M", value: "机械设备-M" },
    { label: "液压设备-P", value: "液压设备-P" },
    { label: "电气设备-E", value: "电气设备-E" },
    { label: "润滑设备-L", value: "润滑设备-L" },
    { label: "水处理设备-W", value: "水处理设备-W" },
    { label: "构筑物（管道）-A", value: "构筑物（管道）-A" },
    { label: "仪表设备-I", value: "仪表设备-I" },
    { label: "工业厂房-C", value: "工业厂房-C" },
    { label: "计算机设备-J", value: "计算机设备-J" },
    { label: "其他设备-Z", value: "其他设备-Z" },
    { label: "通讯及工业电视-T", value: "通讯及工业电视-T" },
    { label: "炉窖设备-F", value: "炉窖设备-F" },
    { label: "空调设备-K", value: "空调设备-K" },
]
export const units = ['', "℃", "A", "V", "kW", "m²", "m³", "mg/m³"]

export const attributes = [
    {
        group: '设备出厂信息',
        list: [
            {
                id: uuidv4(),
                name: "设备名称",
                default: "",
                unit: "无",
                dtype: "string",
                disabled: true,
                qrcodeChecked: true,
                required: false
            },
            {
                id: uuidv4(),
                name: "设备厂商",
                default: "",
                unit: "无",
                dtype: "string",
                disabled: true,
                qrcodeChecked: true,
                required: false
            }, {
                id: uuidv4(),
                name: "设备品牌",
                default: "",
                unit: "无",
                dtype: "string",
                disabled: true,
                qrcodeChecked: true,
                required: false
            }, {
                id: uuidv4(),
                name: "设备型号",
                default: "",
                unit: "无",
                dtype: "string",
                disabled: true,
                qrcodeChecked: true,
                required: false
            },
            {
                id: uuidv4(),
                name: "序列号",
                default: "",
                unit: "无",
                dtype: "string",
                disabled: true,
                qrcodeChecked: true,
                required: true
            },
        ]
    },
    {
        group: '设备管理信息',
        list: [
            {
                id: uuidv4(),
                name: "发货时间",
                default: "",
                unit: "无",
                dtype: "string",
                disabled: true,
                required: true
            },
            {
                id: uuidv4(),
                name: "设备状态",
                default: "",
                unit: "无",
                dtype: "string",
                disabled: true,
                required: false,
                options: [
                    { label: i18n.global.t('在用'), value: "在用" },
                    { label: i18n.global.t('报废'), value: "报废" }
                ]
            },
            {
                id: uuidv4(),
                name: "设备资产编码",
                default: "",
                unit: "无",
                dtype: "string",
                disabled: true,
                required: false
            },
            {
                id: uuidv4(),
                name: "质保到期时间",
                default: "",
                unit: "无",
                dtype: "string",
                disabled: true,
                required: false
            },
            {
                id: uuidv4(),
                name: "应用行业",
                default: "",
                unit: "无",
                dtype: "string",
                disabled: true,
                required: false,
                options: APP_INDUSTRY_LIST
            },
            {
                id: uuidv4(),
                name: "所在位置",
                default: "",
                unit: "无",
                dtype: "string",
                disabled: true,
                required: false
            },
            {
                id: uuidv4(),
                name: "详细地址",
                default: "",
                unit: "无",
                dtype: "string",
                disabled: true,
                required: false
            },
            {
                id: uuidv4(),
                name: "应用车间",
                default: "",
                unit: "无",
                dtype: "string",
                disabled: true,
                required: false
            },
            {
                id: uuidv4(),
                name: "应用工艺",
                default: "",
                unit: "无",
                dtype: "string",
                disabled: true,
                required: false
            },
            {
                id: uuidv4(),
                name: "设备联系人",
                default: "",
                unit: "无",
                dtype: "string",
                disabled: true,
                required: false
            },
            {
                id: uuidv4(),
                name: "设备联系电话",
                default: "",
                unit: "无",
                dtype: "string",
                disabled: true,
                required: false
            }
        ]
    },
    {
        group: '商务信息',
        list: [
            {
                id: uuidv4(),
                name: "维保服务商",
                default: "",
                unit: "无",
                dtype: "string",
                disabled: true,
                required: false,
                options: []
            },
            {
                id: uuidv4(),
                name: "客户名称",
                default: "",
                unit: "无",
                dtype: "string",
                disabled: true,
                required: false,
                options: []

            },
            {
                id: uuidv4(),
                name: "客户编码",
                default: "",
                unit: "无",
                dtype: "string",
                disabled: true,
                required: false
            },
            {
                id: uuidv4(),
                name: "客户属性",
                default: "",
                unit: "无",
                dtype: "string",
                disabled: true,
                options: CUSTOME_ATTR_LIST
            },
            {
                id: uuidv4(),
                name: "客户行业",
                default: "",
                unit: "无",
                dtype: "string",
                disabled: true,
                required: false,
                options: CUSTOMER_INDUSTRY_LIST
            },
            {
                id: uuidv4(),
                name: "所在位置",
                default: "",
                unit: "无",
                dtype: "string",
                disabled: true,
                required: false
            },
            {
                id: uuidv4(),
                name: "客户地址",
                default: "",
                unit: "无",
                dtype: "string",
                disabled: true,
                required: false
            },
            {
                id: uuidv4(),
                name: "客户电话",
                default: "",
                unit: "无",
                dtype: "string",
                disabled: true,
                required: false
            },
            {
                id: uuidv4(),
                name: "客户邮箱",
                default: "",
                unit: "无",
                dtype: "string",
                disabled: true,
                required: false
            },
            {
                id: uuidv4(),
                name: "客户官网",
                default: "",
                unit: "无",
                dtype: "string",
                disabled: true,
                required: false
            },
            {
                id: uuidv4(),
                name: "客户采购联系人",
                default: "",
                unit: "无",
                dtype: "string",
                disabled: true,
                required: false
            },
            {
                id: uuidv4(),
                name: "客户采购联系人电话",
                default: "",
                unit: "无",
                dtype: "string",
                disabled: true,
                required: false
            },
            {
                id: uuidv4(),
                name: "GDNC订单号",
                default: "",
                unit: "无",
                dtype: "string",
                disabled: true,
                required: false
            },
            {
                id: uuidv4(),
                name: "销售渠道",
                default: "",
                unit: "无",
                dtype: "string",
                disabled: true,
                required: false
            },
            {
                id: uuidv4(),
                name: "销售",
                default: "",
                unit: "无",
                dtype: "string",
                disabled: true,
                required: false
            }
        ]
    }
]
export const validationTips = {
    parentNotNull: i18n.global.t('page.parent-product-not-null'),
    nameNotNull: i18n.global.t('page.name-not-null'),
    charLengthLE50: i18n.global.t('page.length-not-more-than-50'),
    charLengthLE200: i18n.global.t('page.length-not-more-than-200'),
    dataTypeNotNull: i18n.global.t('page.data-type-not-null'),
}

// 维保项目保养选项列表
export const maintenanceItemList = [
    {
        label: i18n.global.t('page.maintenance.FirstLevelMaintenance'),
        value: "1",
        // 维护周期选项列表
        cycleList: [
            {
                label: i18n.global.t('page.maintenance.EveryYear'),
                value: "1Y"
            },
            {
                label: i18n.global.t('page.maintenance.EveryTwoYears'),
                value: "2Y"
            },
            {
                label: i18n.global.t('page.maintenance.EveryThreeYears'),
                value: "3Y"
            },
            {
                label: i18n.global.t('page.maintenance.EveryFiveYears'),
                value: "5Y"
            },
            {
                label: i18n.global.t('page.maintenance.EveryEightYears'),
                value: "8Y"
            }
        ],
        // 默认维护周期
        defaultCycle: "1Y"
    },
    {
        label: i18n.global.t('page.maintenance.SecondLevelMaintenance'),
        value: "2",
        cycleList: [
            {
                label: i18n.global.t('page.maintenance.EveryYear'),
                value: "1Y"
            },
            {
                label: i18n.global.t('page.maintenance.EveryTwoYears'),
                value: "2Y"
            },
            {
                label: i18n.global.t('page.maintenance.EveryThreeYears'),
                value: "3Y"
            },
            {
                label: i18n.global.t('page.maintenance.EveryFiveYears'),
                value: "5Y"
            },
            {
                label: i18n.global.t('page.maintenance.EveryEightYears'),
                value: "8Y"
            }
        ],
        defaultCycle: "3Y"
    },
    {
        label: i18n.global.t('page.maintenance.ReturnToFactoryForOverhaul'),
        value: "3",
        cycleList: [
            {
                label: i18n.global.t('page.maintenance.EveryYear'),
                value: "1Y"
            },
            {
                label: i18n.global.t('page.maintenance.EveryTwoYears'),
                value: "2Y"
            },
            {
                label: i18n.global.t('page.maintenance.EveryThreeYears'),
                value: "3Y"
            },
            {
                label: i18n.global.t('page.maintenance.EveryFiveYears'),
                value: "5Y"
            },
            {
                label: i18n.global.t('page.maintenance.EveryEightYears'),
                value: "8Y"
            }
        ],
        defaultCycle: "5Y"
    },
    {
        label: i18n.global.t('page.maintenance.DailyMaintenance'),
        value: "4",
        // 每天，每周，每月，每季度，每半年，每1年
        cycleList: [
            {
                label: i18n.global.t('page.maintenance.EveryDay'),
                value: "1D"
            },
            {
                label: i18n.global.t('page.maintenance.EveryWeek'),
                value: "1W"
            },
            {
                label: i18n.global.t('page.maintenance.EveryMonth'),
                value: "1M"
            },
            {
                label: i18n.global.t('page.maintenance.EveryQuarter'),
                value: "1Q"
            },
            {
                label: i18n.global.t('page.maintenance.EveryHalfYear'),
                value: "1HY"
            },
            {
                label: i18n.global.t('page.maintenance.EveryYear'),
                value: "1Y"
            }
        ],
        defaultCycle: "1D"
    }
]


//end--物产品创建页面--end

//start--事件管理页面--start
export const eventTypeList = [
    // { label:'全部' ,value:'all'},
    { label: i18n.global.t('page.event-management.warning'), value: 'WARNING' },
    { label: i18n.global.t('page.event-management.reminder'), value: 'NORMAL' },
    { label: i18n.global.t('page.event-management.IntelligentAlarm'), value: 'AIWARNING' },
    { label: i18n.global.t('page.event-management.error'), value: 'ERROR' },
    { label: i18n.global.t('page.event-management.unknown'), value: 'UNKNOWN' },
]
export const eventStateList = [
    // { label:'全部' ,value:'all'},
    // PENDING, PROCESSING, WAITING_CONFIRM, SOLVED, CLOSED
    { label: i18n.global.t('page.event-management.start'), value: 'PENDING' },
    { label: i18n.global.t('page.event-management.BeingProcessed'), value: 'PROCESSING' },
    { label: i18n.global.t('page.event-management.WaitForConfirmation'), value: 'WAITING_CONFIRM' },
    { label: i18n.global.t('page.event-management.closed'), value: 'CLOSED' },
    { label: i18n.global.t('page.event-management.HavePublished'), value: 'SCHEDULED' },
    { label: i18n.global.t('page.event-management.resloved'), value: 'SOLVED' },
]
//end--事件管理页面--end


